import React from 'react';
import { ViewStyle } from 'react-native';
import styled from '@emotion/native';
import Button from '@/shared/components/Button';
import { BodyText } from '@/shared/components/StyledText';
import { lightGreen } from '@/shared/styles/colors';
import { useStripe } from '@/services/stripe/StripeProvider';
import { useGetUser } from '@/shared/hooks/useGetUser';
import useIsDesktop from '@/shared/hooks/useIsDesktop';
import {
  SectionContainer,
  SectionHeader,
} from '@/shared/styles/styledComponents/settings';

const PaymentSection = () => {
  const { openPaymentMethodSheet } = useStripe();
  const { user } = useGetUser();
  const isDesktop = useIsDesktop();

  const handleViewPaymentMethods = async () => {
    if (user?.client?.stripeCustomerId) {
      await openPaymentMethodSheet(user.client.stripeCustomerId);
    }
  };

  const buttonStyle: ViewStyle = {
    width: isDesktop ? 'auto' : '100%',
    height: isDesktop ? 45 : 'auto',
    paddingHorizontal: isDesktop ? 40 : 0,
  };

  return (
    <SectionContainer>
      <SectionHeader>Saved Payments:</SectionHeader>
      <PaymentSubtext>View and update saved cards</PaymentSubtext>

      <PaymentButtonContainer isDesktop={isDesktop}>
        <Button
          text="View Payment Methods"
          onPress={handleViewPaymentMethods}
          variant="tertiary"
          customStyle={buttonStyle}
        />
      </PaymentButtonContainer>
    </SectionContainer>
  );
};

export default PaymentSection;

const PaymentSubtext = styled(BodyText)({
  fontSize: 16,
  color: lightGreen,
  marginTop: 4,
  marginBottom: 16,
});

const PaymentButtonContainer = styled.View<{ isDesktop: boolean }>(
  ({ isDesktop }) => ({
    alignItems: isDesktop ? 'flex-start' : 'center',
    marginBottom: 16,
  }),
);
